import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"mt-6",attrs:{"justify":"center"}},[_c(VCol,{staticClass:"pb-0",attrs:{"cols":"10","sm":"5"}},[_c(VSlider,{attrs:{"min":1,"max":10,"label":_vm.label,"disabled":!_vm.selectedField,"step":"1","ticks":"","thumb-label":""},model:{value:(_vm.affinityScore),callback:function ($$v) {_vm.affinityScore=$$v},expression:"affinityScore"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }